import { useCallback, useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { BrandSalesManagerFormType } from 'typings/form';
import { SalesManagerType } from '../index';

export const useSalesManagers = () => {
  const { id } = useParams();
  const [deleteItemId, setDeleteItemId] = useState<string | undefined>();
  const [isSalesModalOpen, setIsSalesModalOpen] = useState<boolean>(false);
  const [salesManagerToEdit, setSalesManagerToEdit] = useState<BrandSalesManagerFormType | Record<string, string>>({});

  const onSalesModalStateChange = useCallback(() => {
    setIsSalesModalOpen((oState) => !oState);
  }, []);

  const onHandleDelete = useCallback((id: string | undefined) => {
    setDeleteItemId(id);
  }, []);

  const onDeleteModalClose = useCallback(() => {
    setDeleteItemId(undefined);
  }, []);

  const onEditSalesManager = useCallback(
    (_data: SalesManagerType) => {
      setSalesManagerToEdit({
        brandId: id,
        brandSalesManagerId: _data?.brandSalesManagerId,
        salesManagerId: _data?.salesManager?.id,
        salesManagerAssistantId: _data?.salesManagerAssistant?.id,
        countries: _data?.countryResponseList?.map((i) => i.id) || [],
      });
      onSalesModalStateChange();
    },
    [onSalesModalStateChange, id]
  );

  useEffect(() => {
    if (!isSalesModalOpen) {
      setSalesManagerToEdit({});
    }
  }, [isSalesModalOpen]);

  return {
    onSalesModalStateChange,
    isSalesModalOpen,
    deleteItemId,
    onDeleteModalClose,
    onHandleDelete,
    salesManagerToEdit,
    onEditSalesManager,
  };
};
